function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint import/no-named-default: 0 */

import merge from 'lodash/merge';
import uuid from 'uuid/v4';

import { default as actorBuilder, defaultValue as actorDefaultValue } from './actor';
import { default as deviceBuilder, defaultValue as deviceDefaultValue } from './device';
import { default as experimentsBuilder, defaultValue as experimentsDefaultValue } from './experiments';
import { default as experimentMetadataBuilder, defaultValue as experimentMetadataDefaultValue } from './experimentMetadata';
import { default as locationBuilder, defaultValue as locationDefaultValue } from './location';
import { default as objectBuilder, defaultValue as objectDefaultValue } from './objects';
import { default as originBuilder, defaultValue as originDefaultValue } from './origin';
import { default as trackerBuilder, defaultValue as trackerDefaultValue } from './tracker';
import { default as providerBuilder, defaultValue as providerDefaultValue } from './provider';

import { dateTime } from './utils';

/** */


/**
 * Default values:
 *
 * `type`: 'View'
 */


/** */


function routableEventDefaults(eventInput) {
  return merge({
    actor: actorDefaultValue(),
    provider: providerDefaultValue()
  }, eventInput);
}

/**
 * Implements https://github.mpi-internal.com/spt-dataanalytics/event-formats/blob/master/schema/master/events/base-routable-event.json
 */
export function routableEvent(eventInput) {
  return Object.assign({}, eventInput, {
    '@id': uuid(),
    creationDate: dateTime(),
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/base-routable-event.json/128.json#',
    provider: providerBuilder(eventInput),
    actor: actorBuilder(eventInput)
  });
}
routableEvent.defaults = routableEventDefaults;

/**
 * Add default value to TrackerEventInput.
 */
function trackerEventInput(eventInput) {
  return merge({
    actor: actorDefaultValue(),
    experiments: experimentsDefaultValue(),
    experimentMetadata: experimentMetadataDefaultValue(),
    device: deviceDefaultValue(),
    location: locationDefaultValue(),
    object: objectDefaultValue(),
    origin: originDefaultValue(),
    provider: providerDefaultValue(),
    tracker: trackerDefaultValue()
  }, eventInput);
}

/**
 * Implements https://github.mpi-internal.com/spt-dataanalytics/event-formats/blob/master/schema/master/events/tracker-event.json
 */
export function trackerEvent(eventInput, sdkConfig) {
  var _ref = eventInput || {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'View' : _ref$type,
      props = _objectWithoutProperties(_ref, ['type']);

  var input = trackerEventInput(eventInput);

  var _ref2 = sdkConfig || {},
      pageViewId = _ref2.pageViewId;

  return Object.assign({}, props, {
    '@id': uuid(),
    '@type': type,
    pageViewId: pageViewId,
    creationDate: dateTime(),
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/tracker-event.json/226.json',
    actor: actorBuilder(input),
    experiments: experimentsBuilder(input),
    experimentMetadata: experimentMetadataBuilder(input),
    device: deviceBuilder(input),
    location: locationBuilder(input),
    object: objectBuilder(input),
    origin: originBuilder(input),
    provider: providerBuilder(input),
    target: input.target && objectBuilder(Object.assign({}, input, { object: input.target })),
    tracker: trackerBuilder(input)
  });
}
trackerEvent.defaults = trackerEventInput;

export function engagementEvent(eventInput, sdkConfig) {
  return Object.assign(trackerEvent(eventInput, sdkConfig), {
    schema: (eventInput || {}).schema || 'http://schema.adevinta.com/events/engagement-event.json/252.json',
    '@type': 'Engagement'
  });
}
engagementEvent.defaults = trackerEventInput;

export function identity(eventInput) {
  return eventInput;
}
identity.defaults = function () {
  return {};
};